import LandingPage from "./presenters/LandingPagePresenter.jsx";
//import SuggestionsPage from './presenters/suggestionsPagePresenter.jsx';
import { FindClubsPresenter } from "./presenters/FindClubsPresenter.jsx";
import { MyProfileView } from "./views/myProfileView.jsx";
import { ProtectedLayout } from "./protectedLayout.jsx";
import { MyClubPresenter } from "./presenters/MyClubsPresenter.jsx";
import { ClubPresenter } from "./presenters/ClubPresenter.jsx";
import TestView from "./views/testView.jsx";
import { ProfilePresenter } from "./presenters/ProfilePresenter.jsx";

export const routes = [
  {
    path: '/', // Landing page Signup/Signin. 
    element: <LandingPage />,
  },
  // Skyddade routes under ProtectedLayout 
  {
    element: <ProtectedLayout />,
    children: [
      {
        path: '/myClubs',
        element: <MyClubPresenter />,
      },
      {
        path: '/myClubs/:clubId',
        element: <ClubPresenter />,
      },
      {
        path: '/findClubs',
        element: <FindClubsPresenter />,
      },
      {
        path: '/profile',
        element: <ProfilePresenter />,
      },
      
    ]
  }
];